import React, { useRef, useEffect } from "react";
import * as d3 from 'd3';
import { select } from 'd3';
import axios from 'axios'
import { useQuery } from 'react-query'

const fetchData = async (menuKey) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/svc/1${menuKey}`)
    //console.log(data)
    return data;
}

function DataContainerAreaChange(props) {
    const { SelectedPrevYear, SelectedNextYear, SelectedAreaInfo, handleAreaChangeNumber, Color, menu, menuKey } = props;
    const { data, error, isError, isLoading } = useQuery(['dataAreaChange', menuKey], () => fetchData(menuKey));
    const svgRef = useRef(null); //svgRef 로 DOM 조작함.
    const svgWrapper = useRef(null);
    // console.log(SelectedAreaInfo, 'SelectedAreaInfo')

    // SelectedPrevYear: 선택된 이전연도, SelectedNextYear: 선택된 이후연도, data: fetching data
    // console.log(SelectedPrevYear, SelectedNextYear, 'year');//, data, 'data')
    // windowDimensions: width, height
    // console.log(windowDimensions, 'windowDimensions')

    const tcolor = Color, grey = '#EEE';
    const boxWidth = 300, boxHeight = 150;
    const lw = 1, ms = 5, marginWidth = 20, marginHeight = 25;
    const chartWidth = boxWidth - marginWidth * 2;
    const chartHeight = boxHeight - marginHeight * 2;

    // const sdname = '전라남도', sggname = '영광';
    const sdname = SelectedAreaInfo.SD, sggname = SelectedAreaInfo.SG;

    function preprocess(data, sdname, sggname, dateStart, dateEnd) {

        // const d = sggname !== null ? data[sdname][sggname] : data[sdname]['대한민국'];

        //let NaN_years = ['2015','2016','2017','2018','2019','2020','2021']
		let NaN_years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024']

        let d

        if (sggname !== null) {

            if (data[sdname]) {
                d = data[sdname][sggname]
            } else {
                d = []
                for (let y of NaN_years) {
                    d.push({
                        "year": new Date(y, 0),
                        "value": 0
                    })
                }
            }

        } else {
            d = data[sdname]['대한민국']
        }

        if (d !== undefined) {
            for (let i of d) {
                if(i.value === 0){
                    i.value = +i.value || 0;
                    i.year = new Date(i.year);
                } else{
                    i.value = +i.value || NaN;
                    i.year = new Date(i.year);
                }
            }
            // console.log(d)
            return d.filter(x => dateStart <= x.year.getFullYear() && x.year.getFullYear() <= dateEnd);
        } else {
            console.log('d is undefined')
        }

    }

    // -------------------------------------------------------------------------------------------------------------------- 차트시작
    function renderChartTs(data_, svg, sdname, sggname, dateStart, dateEnd) {
        const data = preprocess(data_, sdname, sggname, dateStart, dateEnd); // what if sdname doesn't exist?

        // console.log(data)
        svg
            .append('defs')
            .append('marker')
            .attr('id', 'dot')
            .attr('markerUnits', 'userSpaceOnUse')
            .attr('viewBox', [0, 0, (ms + lw) * 2, (ms + lw) * 2])
            .attr('refX', ms + lw)
            .attr('refY', ms + lw)
            .attr('markerWidth', ms + lw)
            .attr('markerHeight', ms + lw)
            .append('circle')
            .attr('cx', ms + lw)
            .attr('cy', ms + lw)
            .attr('r', ms)
            .style('stroke', tcolor)
            .attr('stroke-width', lw * 3)
            .style('fill', tcolor);

        const yScale = d3.scaleLinear()
            .domain(d3.extent(data, d => d.value)).nice()
            .range([chartHeight, 0]);

        const xScale = d3.scaleTime()
            .domain(d3.extent(data, d => d.year))
            .range([0, chartWidth]);

        // svg.insert('text')
        //     .text(sggname)
        //     .attr('class', 'chartTitle')
        //     .attr('x', margin)
        //     .attr('y', margin);

        const chart = svg.append('g')
            .attr('transform', `translate(${marginWidth}, ${marginHeight})`);

        const DataArray = data.filter((element) => !isNaN(element.value));

        if ( DataArray.length === 0 ){
            svg.insert('text')
                .text('데이터 없음')
                .attr('class', 'noData')
                .attr('x', chartWidth/2 )
                .attr('text-anchor', 'start')
                .attr('y', chartHeight/2 )
                .attr('dominant-baseline', 'central')
                .style('fill', 'darkGrey');
        } else {
            svg.selectAll("noData").remove();
        }

        // line chart
        chart.append('path')
            .datum(data)
            .attr('fill', 'none')
            .attr('stroke', tcolor)
            .attr('stroke-dasharray', '3, 3')
            .attr('stroke-width', lw)
            .attr('marker-start', 'url(#dot)')
            .attr('marker-mid', 'url(#dot)')
            .attr('marker-end', 'url(#dot)')
            .attr('stroke-linecap', 'round')
            .attr('d', d3.line()
                .defined(d => !isNaN(d.value))
                .x(d => xScale(d.year))
                .y(d => yScale(d.value)));

        const mouseOnDot = (event, d) => {
            const coord = d3.pointer(event);
            const popup = chart.append('g')
                .attr('id', `popup${Math.round(d.value)}`);

            popup.append('rect')
                .attr('x', coord[0])
                .attr('y', coord[1] - 20)
                .attr('ry', 3)
                .attr('width', 40)
                .attr('height', 20)
                .attr('fill', '#FFF9')
                .attr('stroke', grey)
                .attr('stroke-width', 1);

            popup.append('text')
                .attr('x', coord[0] + 20)
                .attr('y', coord[1] - 7)
                .attr('text-anchor', 'middle')
                .text(d.value.toFixed(1));
        };

        const mouseOffDot = (event, d) => {
            // const popupId = `#popup${d.value}`;
            const popup = d3.select(`#popup${Math.round(d.value)}`);
            popup.remove();
        };

        chart.append('g')
            .selectAll('circle')
            .data(data)
            .join('circle')
            .attr('cx', d => xScale(d.year))
            .attr('cy', d => yScale(d.value))
            .attr('r', 10)
            .attr('opacity', 0)
            .attr('stroke', tcolor)
            .on('mouseover', mouseOnDot)
            .on('mouseout', mouseOffDot)
            ;


        // const values = data.map(x => x.value).filter(x => !isNaN(x));
        // const dmax = Math.max(...values), dmin = Math.min(...values);

        // valDelta: float = 면적 변화량, pctDelta: float = 면적 변화율
        // 만약 두 연도에 해당하는 값(valY0, valY1) 중 어느 하나라도 null 이면 '-' 돌려줌
        let valY0 = data.find(d => d.year.getFullYear() == SelectedPrevYear) ? data.find(d => d.year.getFullYear() == SelectedPrevYear).value : (data.length > 0 ? data[0].value : null);
        let valY1 = data.find(d => d.year.getFullYear() == SelectedNextYear) ? data.find(d => d.year.getFullYear() == SelectedNextYear).value : (data.length > 0 ? data[data.length - 1].value : null);
        let valDelta = '-', pctDelta = '-';
        if ([valY0, valY1].every(d => !isNaN(d))) {
            let valDelta = valY1 - valY0;
            let pctDelta = (valDelta / valY0) * 100;
            handleAreaChangeNumber(valDelta, pctDelta);
        } else {
            let valDelta = NaN
            let pctDelta = NaN
            handleAreaChangeNumber(valDelta, pctDelta, false);
        };

        // value
        chart.append('g')
            .selectAll('text')
            .data(data)
            .join('text')
            .text(d => {
                let r = '';
                if ([SelectedPrevYear, SelectedNextYear].includes(d.year.getFullYear())) {
                    r = !isNaN(d.value) ? d.value.toFixed(1) : '-';// address NaN values
                }
                return r;
            })
            // .attr('class', 'timeSeriesValue')
            .attr('fill', tcolor)
            .attr('x', d => xScale(d.year))
            .attr('y', d => yScale(d.value))
            .attr('dy', -10)
            .style('fill', '#000000')
            .attr('text-anchor', 'middle');

        // xticks
        let xticks = [SelectedPrevYear, SelectedNextYear];
        chart
            .append('g')
            .selectAll('text')
            .data(xticks)
            .join('text')
            .text(d => d)
            .attr('class', 'xticks')
            .attr('x', (d, i) => i * chartWidth)
            .attr('y', marginHeight + chartHeight)
            .attr('text-anchor', 'middle');

        // chart.append('g')
        //     .attr('id', 'y')
        //     .attr('class', 'scale')
        //     .call(d3.axisLeft(yScale)
        //         .ticks(4)
        //         .tickFormat(d3.format('.0f'))
        //     );

        // chart.append('g')
        //     .attr('id', 'x')
        //     .attr('class', 'scale')
        //     .attr('transform', `translate(0, ${chartHeight})`)
        //     .call(d3.axisBottom(xScale)
        //         .ticks(2));
        return chart;
    }

    // -------------------------------------------------------------------------------------------------------------------- 차트종료

    useEffect(() => {
        const svg = select(svgRef.current); // selection 객체
        // chartWidth = ((windowDimensions.width - 286 - 289) / 2);

        if (data && data !== undefined) {
            svg.selectAll('*').remove() //이전 svg 제거
            renderChartTs(data, svg, sdname, sggname, SelectedPrevYear, SelectedNextYear);
        }
    }, [data, SelectedPrevYear, SelectedNextYear, SelectedAreaInfo, menu]); //data 변경시 렌더링함.

    if (isLoading) {
        return <div>Loading...</div>
    }
    if (isError) {
        return <div>Error! {error.message}</div>
    }

    return (
        <div ref={svgWrapper}>
            <svg ref={svgRef}></svg>
        </div>
    );
}

export default DataContainerAreaChange
